import BaseChartMap from './BaseChartMap';

export default BaseChartMap;
